export const personRole = {
	ROLE_VIJFXBETER_USER: 'ROLE_VIJFXBETER_USER',
	ROLE_VIJFXBETER_COACH: 'ROLE_VIJFXBETER_COACH',
	ROLE_VIJFXBETER_ADMIN: 'ROLE_VIJFXBETER_ADMIN',
	ROLE_VIJFXBETER_GEVAARLIJKESTOFFEN_SPECIAL_USER: 'ROLE_VIJFXBETER_GEVAARLIJKESTOFFEN_SPECIAL_USER',
	ROLE_VIJFXBETER_BRONDATABASE: 'ROLE_VIJFXBETER_BRONDATABASE'
} as const;

export type IPersonRole = typeof personRole[keyof typeof personRole];
